import axios, { CancelTokenSource } from "axios"
import {
  cuentaContableEmpresaAdapter,
  cuentaContableEmpresaIdAdapter,
} from "./CuentaContableEmpresa.adapter"
import { CuentaContableEmpresaReadingDtoProps } from "./DTOs/CuentaContableEmpresaReadingDto"
import { CuentaContableEmpresaReadingSimpleDtoProps } from "./DTOs/CuentaContableEmpresaReadingSimpleDto"
import { CuentaContableEmpresaReadingDtoIPagedEnumerableProps } from "./Schemas/CuentaContableEmpresaReadingDtoIPagedEnumerable"
import { CategoriaCuentaContableEnumType } from "./Types/CategoriaCuentaContableEnum"
import { CuentaContableGrupoEnumType } from "./Types/CuentaContableGrupoEnum"
import { SortingCriteria } from "./interfaces/SortingCriteria"

export async function getEntidadCuentaContableEmpresa(
  entidad?: CategoriaCuentaContableEnumType
): Promise<CuentaContableEmpresaReadingDtoProps[]> {
  const { data } = await axios.get(
    `CuentaContableEmpresa/entidad/${entidad ?? ""}`
  )

  return data?.map((movimiento: CuentaContableEmpresaReadingDtoProps) =>
    cuentaContableEmpresaAdapter(movimiento)
  )
}

export interface CuentaContableEmpresaByFilterParamsProps {
  CuentaContableGrupo?: CuentaContableGrupoEnumType
  Keyword?: string
  FechaFinMovimiento?: string
  FechaInicioMovimiento?: string
  TieneMovimientos?: boolean
  SortingCriteria?: SortingCriteria
  IsEnabled?: boolean
  MaxResultCount?: number
  SkipCount?: number
}

/**
 * Retrieves a list of cuenta contable empresa based on the provided filter parameters.
 *
 * @param queryParams - The filter parameters for the cuenta contable empresa.
 * @returns A promise that resolves to a paged enumerable of cuenta contable empresa.
 */

// eslint-disable-next-line import/no-mutable-exports
export let cuentasContablesByFilterCall: CancelTokenSource | undefined
export async function getCuentaContableByFilter(
  queryParams?: CuentaContableEmpresaByFilterParamsProps
): Promise<CuentaContableEmpresaReadingDtoIPagedEnumerableProps> {
  if (typeof cuentasContablesByFilterCall !== typeof undefined) {
    cuentasContablesByFilterCall?.cancel("Previous Request Cancelled")
  }
  cuentasContablesByFilterCall = axios.CancelToken.source()
  const { data } = await axios.get("CuentaContableEmpresa/by-filters", {
    params: queryParams,
    cancelToken: cuentasContablesByFilterCall.token,
  })

  return {
    currentPage: data.currentPage,
    items: data.items?.map((item: CuentaContableEmpresaReadingDtoProps) =>
      cuentaContableEmpresaAdapter(item)
    ),
    totalCount: data.totalCount,
  }
}

export async function getCuentaContableById(
  id: string
): Promise<CuentaContableEmpresaReadingSimpleDtoProps> {
  const { data } = await axios.get(`CuentaContableEmpresa/${id}`)

  return cuentaContableEmpresaIdAdapter(data)
}

export async function deleteCuentaContableById(id: string) {
  return axios.delete(`CuentaContableEmpresa/${id}`)
}
